import React, { useEffect, useState } from 'react'
import './SectionPortfolio.css'
import PortfolioProjectOverview from './PortfolioProjectOverview';
import PortfolioThumbnail from './PortfolioThumbnail'
import { ProjectRepository } from '../../../services/ProjectRepository';
import { NavigationLevel, NavigationUtility } from '../../../Utilities/NavigationUtility';
import { Collapse } from 'react-bootstrap';

export interface PortfolioProject {
    name: string;
    description: string;
    responsibilities: string[];
    thumbnailImageName: string;
    bannerImgName?: string;
    youtubeId?: string;
    links?: [string, string][];
}

const SectionPortfolio = () => {
    const projectRepo = new ProjectRepository();

    const [projects, setProjects] = useState<PortfolioProject[]>(projectRepo.getAllProjects());
    const [projectChosen, setChosenProject] = useState<PortfolioProject>();
    const [show, setShow] = useState<boolean>(false);

    const onPortfolioClicked = (index: number) => {
        setChosenProject(projects[index]);
        setShow(true);

        NavigationUtility.navigateTo(NavigationLevel.Portfolio);
    }

    const onCloseClicked = () => {
        setShow(false);
    }

    const showProject = () => {
        return (
            <Collapse in={show} unmountOnExit={true}>
                <div>
                    <div className="d-flex flex-row-reverse">
                        <p className="close-btn" onClick={onCloseClicked} >&times;</p>
                    </div>
                    <PortfolioProjectOverview project={projectChosen} />
                </div>
            </Collapse>
        )
    }

    return (
        <div>
            <h1 className="section-header pb-0">Portfolio</h1>
            <hr className="w-50 mx-auto" />

            {showProject()}

            <div className="row">
                {projects.map((project, index) => {
                    return <PortfolioThumbnail
                        portfolioIndex={index}
                        imageName={project.thumbnailImageName}
                        callback={onPortfolioClicked}
                    />
                })}
            </div>
        </div>
    )
}

export default SectionPortfolio
